<template>
    <div>
        <div :class="['dop-pack-yellow', 'rounded-xl-7', 'activated' ]">
            <div class="dop-pack-name">{{ $t('course_consist') }}:</div>

            <div
                    class="course-set-item"
                    v-if="course.sostav_val1 && course.sostav_name1"
            >
                <span class="course-set-item__count">{{ course.sostav_val1 }}</span>
                {{ course.sostav_name1 }}
            </div>

            <div
                    class="course-set-item"
                    v-if="course.sostav_val2 && course.sostav_name2"
            >
                <span class="course-set-item__count">{{ course.sostav_val2 }}</span>
                {{ course.sostav_name2 }}
            </div>

            <div
                    class="course-set-item"
                    v-if="course.sostav_val3 && course.sostav_name3"
            >
                <span class="course-set-item__count">{{ course.sostav_val3 }}</span>
                {{ course.sostav_name3 }}
            </div>

            <div
                    class="course-set-item"
                    v-if="course.sostav_val4 && course.sostav_name4"
            >
                <span class="course-set-item__count">{{ course.sostav_val4 }}</span>
                {{ course.sostav_name4 }}
            </div>

            <div
                    class="course-set-item"
                    v-if="course.sostav_val5 && course.sostav_name5"
            >
                <span class="course-set-item__count">{{ course.sostav_val5 }}</span>
                {{ course.sostav_name5 }}
            </div>


            <div class="dop-pack-price"
                 v-if="course.price > 0">
                <span class="dop-pack-price-value">{{course.price | formatPrice}}</span>
                <span
                        class="dop-pack-rub">{{ $t('cur') }}</span>
                <span class="dop-pack-before"
                      v-if="course.pricebefore > 0">{{course.pricebefore | formatPrice}} {{ $t('cur') }}</span>
            </div>
            <div class="dop-pack-btn-line">
                <base-button
                        :data-id="course.idcourse"
                        data-model="course"
                        :data-price="course.price"
                        data-action="order"
                        :data-label="orderButtonText"
                        class="ma-0 dop-pack-btn"
                        @click="order"
                >
                    {{orderButtonText}}
                </base-button>
            </div>

        </div>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<style>

    .course-set-item {
        color: #4f4d5c;
        font-size: 16px;
        margin-bottom: 5px;
    }

    .course-set-item__count {
        color: #ed1c24;
        font-family: "Manrope Bold";
        font-size: 19px;
    }

    .zapis a, .zapis .btn {
        background: #ed1c24;
        padding: 10px 15px;
        min-width: 150px;
        border-radius: 18px;
        color: #fff;
        font-family: Manrope Bold;
        font-size: 18px;
        text-shadow: 1px 2px 1px rgba(0, 0, 0, 0.75);
        box-shadow: 1px 1px 3px 0 rgba(40, 40, 40, 1);
        border: none;
    }

    .cena {
        color: #231c37;
        font-size: 30px;
        font-family: Manrope Bold;
    }

    .rub {
        color: #4f4d5c;
        font-size: 16px;
        margin-left: 5px;
    }


</style>
<script>
    import numeral from 'numeral';

    export default {
        props: ['course'],
        name: 'CourseSostav',

        computed: {
            orderButtonText() {
                if (this.course.ordered) {
                    return this.$t('go_to');
                } else if (this.course.preorder) {
                    return this.$t('preorder');
                } else if (parseInt(this.course.price) === 0) {
                    return this.$t('subscribe');
                }
                return this.$t('buy');
            },

        },

        methods: {
            order() {
                this.$emit("order");
            }
        },

        filters: {
            formatPrice: function (value) {
                return numeral(value).format("0,0.00").replace(/\.0+$/,'').replace(/,/g, '\u00A0')
            }
        }
    }
</script>
